import { render, staticRenderFns } from "./LotteryStart.vue?vue&type=template&id=3d8f1480&"
import script from "./LotteryStart.vue?vue&type=script&lang=js&"
export * from "./LotteryStart.vue?vue&type=script&lang=js&"
import style0 from "./LotteryStart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports